import slideshow from './grouped-tiles-slideshow';

slideshow('#prod-detail-gallery-thumbs', {
  slidesPerView: 4,
  slidesPerGroup: 4,
});